'use client'

import { useEffect } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { isStaleClientError, reportClientError } from '@/app/_lib/clientErrorReporter'
import logoGray from '../public/images/hive-logo-gray.png'

/**
 * Route segment error boundary.
 *
 * React hands boundary-caught errors to onCaughtError, which never reaches
 * window.onerror — so useErrorReporting cannot see these. This component is
 * the only place a route-level render error can be captured.
 */
export default function Error({ error, reset }) {
    useEffect(() => {
        console.error('[Error Boundary]', error)

        // Auto-reload for stale client errors
        if (isStaleClientError(error)) {
            console.log('[Error Boundary] Stale client detected, reloading page...')
            window.location.reload()
            return
        }

        reportClientError({ error, type: 'route' })
    }, [error])

    // If we get here, it's not a stale client error - show UI
    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center">
            <Link href="/" className="mb-8">
                <Image
                    src={logoGray}
                    alt="hive modern"
                    width={120}
                    height={60}
                    priority
                />
            </Link>
            <h1 className="text-3xl font-light mb-3">We hit a snag</h1>
            <p className="text-gray-600 mb-8 max-w-md">
                Something unexpected happened. Please try again, or return to our homepage to continue shopping.
            </p>
            <div className="flex gap-4">
                <button
                    onClick={() => reset()}
                    className="btn btn-dark"
                >
                    Try again
                </button>
                <Link href="/" className="btn btn-outline">
                    Go to homepage
                </Link>
            </div>
        </div>
    )
}
